// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get, HasPagingParameters, post } from "@insite/client-framework/Services/ApiService";
import { WarehouseCollectionModel } from "@insite/client-framework/Types/ApiModels";

export interface GetWarehousesApiParameter extends ApiParameter, HasPagingParameters {
    search: string;
    latitude: number;
    longitude: number;
    radius?: number;
    onlyPickupWarehouses?: boolean;
    excludeCurrentPickupWarehouse?: boolean;
}

const warehousesAlphabetUrl = "/api/v1/warehouses";

export function getWarehouses(parameter: GetWarehousesApiParameter) {
    return get<WarehouseCollectionModel>(`${warehousesAlphabetUrl}/`, parameter);
}

// XNG-Custom
const warehouseTransferUrl = "/api/pls/WareHouseTransfer";

interface InHeader {
    ToWarehouse: string;
    Warehouse: string;
}
interface InLines {
    ProductCode: string;
    QuantityOrdered: number | null;
}

export interface Items extends ApiParameter {
    Inheader: InHeader[];
    Inlines?: InLines[];
}

export function postWarehouseTransfer(parameter: Items) {
    return post<Items>(`${warehouseTransferUrl}/`, parameter);
}
